module.exports = __webpack_public_path__ + "static/img/IMG_20240101_205605.ccc716c4.jpg";